<template>
  <div class="my-shop-page--main-wrapper">
    <top-header></top-header>
	<b-container fluid >
		<b-row class="mb-3">			
			<b-col cols="3" id="sidebar-fifi-toggle" v-if="!statusSidebar">
				<top-nevleft></top-nevleft>
				
			</b-col>
		 <b-col>
			<b-row class="breadcrumbrow"><b-col>			
			<a v-if="!statusSidebar" href="javascript:void(0)" id="menu-toggle" @click="burgerMenuSidebar" v-b-toggle="'sidebar-fifi-toggle'">	<i class="fa fa-arrow-left" style="font-size:24px"></i> Close Menu</a>
			<a v-else href="javascript:void(0)"  id="menu-toggle" @click="burgerMenuSidebar" v-b-toggle="'sidebar-fifi-toggle'"><i class="fa fa-bars" aria-hidden="true" style="font-size:24px"></i></a>
			</b-col></b-row>

    <div class="my-shop-page--outer-wrapper">
      <b-container>
        <span class="my-shop-txt d-block">My Shop</span>
        <div class="my-shop--tabs-wrapper">
          <b-tabs
            active-tab-class="my-shop-active-tab-content mt-3"
            nav-class="my-shop-tabs"
            fill>
            <b-tab title="Product List" active>
              <div class="product-list--table-wrapper">
                <div class="product-list--table-header-wrapper">
                  <b-row>
                    <b-col md="8" offset-md="4" class="pricing-column-wrapper">
                      <b-row>
                        <b-col md="3" class="pricing-column text-center">
                          <span class="pricing-txt">Seller Price</span>
                        </b-col>
                        <b-col md="3" class="pricing-column text-center">
                          <span class="pricing-txt">Special Price</span>
                        </b-col>
                        <b-col md="3" class="pricing-column text-center">
                          <span class="pricing-txt">Commission</span>
                        </b-col>
                        <b-col md="3" class="pricing-column text-center">
                          <span class="pricing-txt">Discount</span>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <div class="product-list--table-row-wrapper" v-for="product in products" :key="product.id">
                  <b-row >
                    <b-col cols="4" md="4">
                      <div
                        class="product-info-wrapper d-flex justify-content-between">
                        <div class="product-img-wrapper">
                          <a :href="'/product/'+product.product_id">
                          <b-img
                            :src="$root.MEDIAAPI+'toolimage/get_image?size=200x200&src='+product.image"
                            :alt="product.title"></b-img>
                          </a>
                        </div>
                        <div class="product-content-wrapper d-flex flex-column">
                          <span class="product-title">{{product.title}}</span>
                          <product-rating :userrating="product.total_rating"></product-rating>
                          
                          <a @click="addToBucket(product)"
                            class="create-list-cta d-flex align-items-center"
                            v-b-modal="'create-list-modal'">
                            <div class="icon-wrapper d-flex flex-column justify-content-center align-items-center mr-2">
                              <b-icon icon="plus"></b-icon>
                            </div>
                            <span>Create List</span>
                          </a>
                        </div>
                      </div>
                    </b-col>
                    <b-col md="2" class="pricing-column text-center">
                      <span class="pricing-value-txt">{{product.price}}</span>
                    </b-col>

                    <b-col md="2" class="pricing-column text-center">
                      <span class="pricing-value-txt">{{product.special_price}}</span>
                    </b-col>

                    <b-col md="2" class="pricing-column text-center">
                      <span class="pricing-value-txt">{{product.commission}}%</span>
                    </b-col>

                    <b-col md="2" class="pricing-column text-center">
                      <span class="pricing-value-txt">0%</span>
                    </b-col>
                  </b-row>

                  <b-row class="start-selling-product-wrapper-row">
                    <b-col md="4" class="start-selling-product-wrapper-col">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="start-selling-txt">Start Selling</span>
                        <ul class="social-media-list p-0">
                          <li>
                            <a href="javascript:void(0)">
                              <b-img
                                src="../../assets/twitter.png"
                                alt="Start selling on Twitter"
                              ></b-img>
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0)">
                              <b-img
                                src="../../assets/facebook.png"
                                alt="Start selling on Fcebook"
                              ></b-img>
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0)">
                              <b-img
                                src="../../assets/Instagram.png"
                                alt="Start Selling on Instagram"
                              ></b-img>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <b-button type="button" pill class="btn--load-more" v-if="nextPage" @click="loadMore()">Load More</b-button>
            </b-tab>
            <b-tab title="Recommended">
              <h3>Recommended</h3>
            </b-tab>
            <b-tab title="Top Selling">
              <h3>Top Selling</h3>
            </b-tab>
            <b-tab title="Vouchers">
              <h3>Vouchers</h3>
            </b-tab>
            <b-tab title="Favorites">
              <h3>Favorites</h3>
            </b-tab>
            <b-tab title="Performance">
              <h3>Performance</h3>
            </b-tab>
          </b-tabs>
        </div>
      </b-container>
    </div>
	</b-col>
		</b-row>
		</b-container>
    <top-footer></top-footer>

    <b-modal id="create-list-modal" hide-footer>
      <template #modal-title> Selected Products </template>
      <div  class="selected-products-wrapper d-flex flex-wrap justify-content-between">
        <div class="product-wrapper d-flex justify-content-between" v-for="(product,idx) in bucket" :key="idx">
          <div class="product-img-wrapper">
            <b-img :src="$root.MEDIAAPI+'toolimage/get_image?size=200x200&src='+product.image" :alt="product.title"></b-img>
          </div>
          <div class="product-content-wrapper d-flex flex-column">
            <span class="product-title">{{product.title}}</span>
            <product-rating :userrating="product.total_rating"></product-rating>
            <a @click="removeBucket(idx)" class="remove-product-link">Remove</a>
          </div>
        </div>
      </div>
      <div class="message-textarea-wrapper">
        <b-form-textarea
          id="message-textarea"
          rows="8"
          placeholder="Type your message here"
        ></b-form-textarea>
      </div>
      <div
        class="product-share-wrapper d-flex justify-content-center align-items-ceter">
        <span class="product-share-txt align-self-center mr-4">Share Now</span>
        <ul class="social-media-list p-0">
          <li>
            <a href="javascript:void(0)">
              <b-img
                src="../../assets/twitter.png"
                alt="Start selling on Twitter"
              ></b-img>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)">
              <b-img
                src="../../assets/facebook.png"
                alt="Start selling on Fcebook"
              ></b-img>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)">
              <b-img
                src="../../assets/Instagram.png"
                alt="Start Selling on Instagram"
              ></b-img>
            </a>
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import ProductRating from "@/components/product-rating.vue";
import TreeviewPage from "@/components/common/nevleft.vue";
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
    "top-header": Header,
		"top-footer": Footer,
    "product-rating": ProductRating,
	"top-nevleft": TreeviewPage,
	},
	mounted(){
        this.initload();
	},
	data() {
		return{
		statusSidebar: false,
      nextPage:0,
      products: [],
      bucket:[],
			url: this.$root.WEBURL+'my-shop',
		};
	},
	methods: {
	burgerMenuSidebar() {
		  this.statusSidebar = !this.statusSidebar;
		},
    loadMore(){
      this.initload();
    },
    removeBucket(id){
      this.bucket.splice(id, 1);
    },
    addToBucket(product){
      if(this.bucket.length >= 4){
        this.$bvToast.toast('No more products can be add to list!', {
          title: `Alert`,
          variant: 'warning',
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: true
        })
        return false;
      }
      this.bucket.push(product);
    },
		initload(){
			var self = this;
			self.axios.post(self.url, {
        accesskey: self.$root.customer_info.access_key,
        page:self.nextPage
			}).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
          for(let p of response.data.result.products){
            self.products.push(p);
          }
          self.nextPage = response.data.result.pagination.next;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			}).catch(function (error) {
				alert(error);
			});
		}
	}
}
</script>
<style scoped lang="scss">
$whiteColor: #ffffff;
$blackColor: #000000;
$themeColor: #a059d9;
$themeColor2: #8507d6;
$themeColor3: #b24bf1;
$redColor: #e61583;
$grey: #b9b9b9;
$grey2: #a6a6a6;
$themeLightColor: #f2e2ff;
$themeDarkColor: #df007e;

@mixin setBlackBoldTextStyles() {
  font-size: 16px;
  color: $blackColor;
  font-weight: bold;
}

.my-shop-page {
  &--main-wrapper {
    width: 100%;
    position: relative;
    background: $whiteColor;
  }
}

.my-shop-txt {
  margin: 20px 0 20px;
  font-size: 22px;
  font-weight: bold;
  color: $blackColor;
}

.product-list {
  &--table-wrapper {
    width: 100%;
    position: relative;
    background-color: $whiteColor;
    border: 1px solid $grey;
    border-top: 0;
    margin-top: 40px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  &--table-header-wrapper {
    padding: 10px 0;
    background-color: $themeColor;
    border-radius: 50px;
    position: relative;
    top: -20px;
    margin-bottom: -20px;

    .pricing-column-wrapper {
      .pricing-column .pricing-txt {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }

  &--table-row-wrapper {
    padding: 24px 40px;
    border-bottom: 2px solid $themeLightColor;

    &:last-child {
      border-bottom: 0;
    }

    .start-selling-product-wrapper {
      &-row {
        position: relative;
        margin-top: -55px;
        z-index: 0;

        .start-selling-txt {
          @include setBlackBoldTextStyles();
        }
      }

      &-col {
        margin-left: auto;
        max-width: 285px;
      }
    }

    .pricing-column {
      border-right: 1px solid $grey;
      align-self: flex-start;
      padding: 18px 0;

      &:last-child {
        border-right: none;
      }

      .pricing-value-txt {
        @include setBlackBoldTextStyles();
      }
    }
  }
}

.product-info-wrapper {
  padding: 18px 0;
  .product-img-wrapper {
    width: 120px;

    img {
      width: 100%;
    }
  }

  .product-content-wrapper {
    width: calc(100% - 120px);
    padding-left: 40px;

    .product-title {
      @include setBlackBoldTextStyles();
    }

    .create-list-cta {
      color: $themeDarkColor;
      font-weight: bold;
      font-size: 14px;
      z-index: 9;

      .icon-wrapper {
        width: 34px;
        height: 30px;
        padding: 8px 10px;
        border: 2px solid $themeDarkColor;
        border-radius: 4px;

        svg {
          fill: $themeDarkColor;
        }
      }
    }
  }
}
.product-rating-outer-wrapper {
  margin: 18px 0;

  .product-rating-wrapper {
    width: 24px;
    margin-right: 5px;
    overflow: hidden;
    display: inline-block;

    &:last-child {
      margin-right: 0;
    }

    &--create-list-modal {
      width: 18px;
    }
  }
}
.social-media-list {
  display: flex;
  margin: 0;

  li {
    margin-right: 5px;

    &:last-child {
      margin-right: 0;
    }

    a {
      display: block;

      img {
        width: 40px;
      }
    }
  }
}

#create-list-modal {
  .selected-products-wrapper {
    .product-wrapper {
      width: 50%;
      max-width: 300px;
      margin-bottom: 45px;

      .product-img-wrapper {
        width: 120px;
        text-align: center;

        img {
          max-height: 100px;
        }
      }

      .product-content-wrapper {
        width: calc(100% - 120px);
        padding-left: 40px;

        .product-title {
          @include setBlackBoldTextStyles();
        }

        .remove-product-link {
          font-size: 14px;
          color: $grey2;
        }
      }
    }
  }
  .product-share-wrapper {
    margin-top: 24px;
  }
}

#message-textarea {
  border-color: $themeDarkColor;

  :focus {
    border-color: $themeColor2;
  }
}
</style>